import { cn } from "../lib/utils";

/**
 * Eyebrow label — italic amber `// text` exactly like Zolt theme
 */
export const Eyebrow = ({ children, className }) => (
  <p className={cn("text-accent text-lg font-medium italic", className)}>
    {"// "}{children}
  </p>
);

export default Eyebrow;
